import { apiRequest } from "../api/apiClient";

const ROUTE_PREFIX = "washBooking";

const bookCarWash = async (
  packageId: string,
  cityId: string,
  carId: string,
  slotRef: string,
  date: string,
  slotTime: string,
  price: string,
  city: string,
) => {
  const { data, error } = await apiRequest("post", `/${ROUTE_PREFIX}`, {
    packageId,
    cityId,
    slotRef,
    date,
    city,
    carId,
    slotTime,
    price,
  });

  return { data, error };
};

const getWashBookings = async ({
  index = 20,
  city,
  fromDate,
  toDate,
}: {
  index?: number;
  city?: string;
  fromDate?: string;
  toDate?: string;
}) => {
  const queryParams = new URLSearchParams();

  queryParams.append("index", index.toString());

  if (city && city !== "all") {
    queryParams.append("city", city);
  }

  if (fromDate && toDate) {
    queryParams.append("fromDate", fromDate);
    queryParams.append("toDate", toDate);
  }

  const { data, error } = await apiRequest(
    "get",
    `/${ROUTE_PREFIX}/admin?${queryParams.toString()}`,
  );

  return { data, error };
};

const getWashBookingByIds = async (bookingIds: string[]) => {
  const query = bookingIds.join(",");

  const { data, error } = await apiRequest(
    "get",
    `/${ROUTE_PREFIX}?ids=${query}`,
  );

  return { data, error };
};

const updateWashBookingStatus = async (bookingId: string, status: string) => {
  const { data, error } = await apiRequest(
    "put",
    `/${ROUTE_PREFIX}/${bookingId}/status`,
    { status },
  );

  return { data, error };
};

export {
  bookCarWash,
  getWashBookings,
  getWashBookingByIds,
  updateWashBookingStatus,
};
